"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDevice = void 0;
var _mui = require("@ori-ui/mui");
const useDevice = () => {
  const {
    breakpoints
  } = (0, _mui.useTheme)();
  const isDesktop = (0, _mui.useMediaQuery)(breakpoints.up('md'));
  const isMobile = !isDesktop;
  return {
    isDesktop,
    isMobile
  };
};
exports.useDevice = useDevice;
